import { Injectable, effect, inject, signal, untracked } from '@angular/core';
import {
    EventQueryRule,
    IqEventBusBrokerService,
    matchRule,
} from '@dat/iq-event-bus';
import { get, isEmpty } from 'lodash';
import { Dashboard } from '../../models';
import { IqBuilderStateStatusService } from './iq-builder-state-status.service';

@Injectable({
    providedIn: 'root',
})
export class IqBuilderStateRulesService {
    private _bus: IqEventBusBrokerService = inject(IqEventBusBrokerService);
    private _registered = signal(false);

    constructor(private _statusState: IqBuilderStateStatusService) {
        effect(() => {
            const registered = this._registered();

            if (!registered) return;

            untracked(() => {
                this._bus.dispatch({
                    name: 'type:rules:evaluator:register',
                    payload: {
                        evaluator: ({
                            dashboardId,
                            path,
                            rule,
                        }: {
                            dashboardId: string;
                            path: string;
                            rule: EventQueryRule;
                        }): Promise<boolean> => {
                            return this.evaluateCache(dashboardId, path, rule);
                        },
                        type: 'dashboard:cache',
                    },
                });
            });
        });
    }

    register() {
        if (this._registered()) return;

        this._registered.set(true);
    }

    async evaluateCache(
        dashboardId: string,
        path: string,
        rule: EventQueryRule,
    ) {
        const dashboard: Dashboard =
            this._statusState.getDashboardData(dashboardId)();

        if (isEmpty(dashboard)) return Promise.resolve(false);

        const cache = get(dashboard, 'cache', {});
        const cacheValue = !!path?.length ? get(cache, path, {}) : cache;
        const matches = matchRule(cacheValue, rule);

        return Promise.resolve(matches);
    }
}
